import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../../pipes/pipes.module';
import { CodeInputModule } from '../code-input/code-input.module';
import { CustomizeFormModule } from '../customize-form/customize-form.module';
import { AuthPromptPageComponent } from './auth-prompt-page.component';

@NgModule({
  imports: [CommonModule, FormsModule, PipesModule, CodeInputModule, CustomizeFormModule],
  declarations: [AuthPromptPageComponent],
  exports: [AuthPromptPageComponent],
})
export class AuthPromptPageModule {}
